import useCurrentEmail from './useCurrentEmail';

export { useCurrentEmail };
